import { render, staticRenderFns } from "./VolumeOff.vue?vue&type=template&id=5bf1a586"
import script from "./VolumeOff.vue?vue&type=script&lang=js"
export * from "./VolumeOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports